<script setup>
import InfoHolder from "@/components/global/drawer/InfoHolder.vue";
import { useRouter, useRoute } from "vue-router";
import useCompany from "@/composables/useCompany";

const router = useRouter();
const route = useRoute();
const { company } = useCompany();

const goToEdit = () => {
  router.push("/company/edit/" + route.params.id);
};
</script>

<template>
  <div v-if="company" class="pa-5">
    <div class="d-flex align-center justify-space-between">
      <div>
        <h1>{{ company.name }}</h1>
      </div>
      <div>
        <v-btn size="small" color="company" class="mr-5" @click="goToEdit">
          <v-icon>mdi-pencil</v-icon> edit company
        </v-btn>
      </div>
    </div>
    <v-divider />
    <div class="d-flex company-view__box-holder">
      <div class="d-flex company-view__box-row flex-1-0-0">
        <div class="company-view__box-container mt-5">
          <h3 class="pa-2"><v-icon>mdi-domain</v-icon> Company Data</h3>
          <InfoHolder title="Name" :info="company.name" />
          <InfoHolder title="Email" :info="company.email" />
          <InfoHolder title="Telephone" :info="company.telephone" />
          <InfoHolder title="Website" :info="company.website" />
          <InfoHolder title="Location" :info="company.location" />
          <InfoHolder title="Contact Name" :info="company.contactName" />
          <InfoHolder title="Contact Email" :info="company.contactEmail" />
          <InfoHolder
            title="Contact Telephone"
            :info="company.contactTelephone"
          />
          <InfoHolder title="Workforce" :info="company.workforce?.name" />
          <InfoHolder
            title="Talent Platform Profile"
            :info="company.talentPlatformProfile"
          />
          <InfoHolder title="Branch" :info="company.branch?.name" />
          <InfoHolder title="Notes" type="richText" :info="company.notes" />
          <InfoHolder
            title="Company sector"
            :info="company.companySector?.name"
          />
        </div>
      </div>
      <div class="d-flex company-view__box-row flex-1-0-0" style="gap: 10px">
        <div
          class="company-view__box-container company-view__box-container--w3 mt-5"
        >
          <h3 class="pa-2"><v-icon>mdi-briefcase</v-icon> Job Positions</h3>

          <div v-for="job in company.jobPositions" :key="job.id" class="pa-2">
            <router-link
              :to="'/company/job-position/view/' + job.id"
              target="_blank"
              class="chip-link-color-company"
            >
              <v-chip> {{ job.name }} </v-chip>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
  color: rgb(var(--v-theme-company));
}

.company-view__box-holder {
  gap: 20px;
  .company-view__box-row {
    flex-direction: column;
    .company-view__box-container {
      border: 1px solid rgb(var(--v-theme-company));
      h3 {
        background-color: rgb(var(--v-theme-company));
        color: black;
      }
      .info {
        .label {
          text-decoration: underline;
        }
        .answer {
          display: block;
          font-weight: bold;
        }
      }
    }
    .company-view__box-container--w3 {
      width: 100%;
    }
  }
}
</style>
